import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { renderHighlightedValue } from '../utils/renderHighlightedValue';
export const builtInCssClasses = {
    option: 'whitespace-no-wrap max-w-full px-3 text-neutral-dark truncate',
    icon: 'w-6 h-full flex-shrink-0 text-gray-400'
};
/**
 * Renders an autocomplete result, including an icon to the left if provided.
 * @param result - The result to render
 * @returns JSX.Element
 */
export function renderAutocompleteResult(result, cssClasses = {}, Icon, ariaLabel) {
    return (_jsxs(_Fragment, { children: [Icon && _jsx("div", Object.assign({ className: cssClasses.icon }, { children: _jsx(Icon, {}, void 0) }), void 0), _jsx("div", Object.assign({ "aria-label": ariaLabel || '', className: cssClasses.option }, { children: renderHighlightedValue(result, cssClasses) }), void 0)] }, void 0));
}
//# sourceMappingURL=renderAutocompleteResult.js.map